import styled from 'styled-components';
export const RegionSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  @media ${({ theme }) => theme.device.medium} {
    margin-bottom: 0;
  }

  &&& > a {
    box-sizing: border-box;
    height: 2.75rem;
    align-items: center;
    margin-right: auto;

    @media ${({ theme }) => theme.device.medium} {
      height: 2.5rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
`;
export const StyledSpan = styled.span `
  display: flex;
  align-self: center;
  box-sizing: border-box;
  height: 2.75rem;
  align-items: center;
  margin-right: auto;

  @media ${({ theme }) => theme.device.medium} {
    height: 2.5rem;
    padding-right: 0.5rem;
  }
`;
